import * as React from 'react';
import {
  IconProductCianLogo16,
  IconMapMetroMsk16,
  IconMapPin16,
  IconActionPinLine16,
  IconPlaceholderBuilder16,
} from '@cian/ui-kit-design-tokens/icons';
import { ISuggestData, ISuggestGroup } from './types';

export const SUGGEST_CATEGORIES: ISuggestGroup[] = [
  {
    key: 'newbuildings',
    label: 'Жилые комплексы',
    icon: <IconProductCianLogo16 color="surface-neutral-pressed" />,
  },
  {
    key: 'undergrounds',
    label: 'Метро',
    icon: <IconMapMetroMsk16 color="surface-neutral-pressed" />,
  },
  {
    key: 'districts',
    label: 'Районы',
    icon: <IconActionPinLine16 color="surface-neutral-pressed" />,
  },
  {
    key: 'builders',
    label: 'Застройщики',
    icon: <IconPlaceholderBuilder16 color="surface-neutral-pressed" />,
  },
  {
    key: 'address',
    label: 'Адреса',
    icon: <IconMapPin16 color="surface-neutral-pressed" />,
  },
];

export const EMPTY_SUGGESTIONS: ISuggestData = {
  address: [],
  builders: [],
  districts: [],
  newbuildings: [],
  undergrounds: [],
};
